import { useSelector } from "react-redux";
import { setTableHeight } from "../../../../functions/setTableHeight";
import { COMPLAINTS_PENDING_HEADERS } from "../../utils/ComplaintsTables.config";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import sortDataByDate from "../../../../functions/sorting/sortDataByDate";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import GetCheckCross from "../../../../components/UI/viewDialogs/GetCheckCross";
import { truncateDesc } from "../../../../functions/truncateDesc";
import {
  filterTableColumns,
  hasAnyRole,
} from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";

const TableComplaintContent = ({ openViewDialog }) => {
  const data = useSelector((state) => state.data.data);
  const isSorted = useSelector((state) => state.data.isSorted);

  let dataList = isSorted ? data : sortDataByDate(data, "createdAt");
  const isDataAvailable = data.length > 0;
  const hasRole = hasAnyRole(adminRoles);
  const filterComplaintHeadList = filterTableColumns({
    headList: COMPLAINTS_PENDING_HEADERS,
    roleConfig: {
      Supervisor: adminRoles,
    },
  });
  return (
    <div className={`table-container ${setTableHeight(isDataAvailable)}`}>
      <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
        <tbody>
          <TableHead headList={filterComplaintHeadList} />
          {isDataAvailable ? (
            <>
              {dataList.map((data, index) => {
                return (
                  <tr className="table-row" key={index}>
                    <td className="text-left">
                      <p className="w-[7rem] whitespace-normal">
                        {data.station.name}
                      </p>
                      <p className="text-xs lg:text-sm text-gray-400 font-normal">
                        SITE ID-{data.station.id}
                      </p>
                    </td>
                    <td>{data.fieldTechnician.fullName}</td>
                    {hasRole && <td>{data.supervisor.fullName}</td>}
                    <td>{formatDate(data.createdAt)}</td>
                    <td>{truncateDesc(data.description)}</td>
                    <td>{data.category.name}</td>
                    <td>
                      {" "}
                      <GetCheckCross checkVal={data.visitIdList?.length > 0} />
                    </td>
                    <td>{formatDate(data.last_visit_date)}</td>
                    <td>
                      <button
                        className="tableViewBtn"
                        onClick={() => openViewDialog(dataList[index])}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </>
          ) : (
            <NoDataDisplay />
          )}
        </tbody>
      </table>
    </div>
  );
};
export default TableComplaintContent;
